import { Component, Input, OnChanges, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { TeamActionMockSettingsService } from '../../team-action-mock-settings.service';
import { memberIssue, MOCK_PEOPLE, MockPerson, MockTeam, teamsOf } from '../../team-action-mock.data';

interface UserTeamRow {
  team: MockTeam;
  issue: string | null;
}

// Maquette d'estimation « action d'équipe » : carte « Équipes » d'un utilisateur (maquette et vraie fiche utilisateur).
@Component({
  selector: 'team-action-mock-user-teams-card',
  templateUrl: './team-action-mock-user-teams-card.component.html',
})
export class TeamActionMockUserTeamsCardComponent implements OnInit, OnChanges {
  @Input() member: MockPerson = MOCK_PEOPLE.paul;
  /** Un clic sur une ligne ouvre la fiche de l'équipe (vrais écrans). */
  @Input() linkable = false;
  /** Mention « données fictives », sur les vrais écrans. */
  @Input() fictive = false;

  readonly displayedColumns = ['name', 'role', 'support', 'status'];
  rows: UserTeamRow[] = [];

  constructor(
    public settings: TeamActionMockSettingsService,
    private router: Router,
  ) {}

  ngOnInit(): void {
    this.buildRows();
  }

  ngOnChanges(): void {
    this.buildRows();
  }

  open(row: UserTeamRow): void {
    if (this.linkable) {
      this.router.navigate(['/management/teams', row.team.id]);
    }
  }

  private buildRows(): void {
    this.rows = teamsOf(this.member).map(team => ({ team, issue: memberIssue(this.member, team) }));
  }
}
